// import * as React from "react";
import { ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-big-calendar/lib/css/react-big-calendar.css";
import * as ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./AuthContext.jsx";
import ProtectedRoute from "./routes/protected.jsx";
import {
   createRoutesFromElements,
   createBrowserRouter,
   Route,
   RouterProvider,
   // Routes
} from "react-router-dom";

import ErrorPage from "./error-page.jsx";
import Login from "./routes/login/login.jsx";
import "./styles/App.css";
import Contact, {
   loader as contactLoader,
   action as contactAction,
} from "./routes/contact.jsx";
import Root, {
   loader as rootLoader,
   action as rootAction,
} from "./routes/root.jsx";
import EditContact, { action as editAction } from "./routes/edit.jsx";
import { action as destroyAction } from "./routes/destroy.jsx";
import Index from "./routes/index";

import Cliente from "./routes/clientes/cliente.jsx";
import FormCliente from "./routes/clientes/formCliente.jsx";

import Insumo from "./routes/insumos/insumo.jsx";
import FormInsumo from "./routes/insumos/formInsumo.jsx";

import Insumot from "./routes/insumost/insumot.jsx";
import FormInsumot from "./routes/insumost/formInsumot.jsx";

import Servicio from "./routes/servicios/servicios.jsx";
import FormServicio from "./routes/servicios/formServicio.jsx";
import FormServins from "./routes/servicios/formServIns.jsx";

import Producto from "./routes/productos/Producto.jsx";
import FormProducto from "./routes/productos/formProducto.jsx";

import Productotattoo from "./routes/productostattoo/Producto.jsx";
import FormProductotattoo from "./routes/productostattoo/formProducto.jsx";

import Usuario from "./routes/usuarios/usuario.jsx";
import FormUsuario from "./routes/usuarios/formUsuario.jsx";

import Pagos from "./routes/FormPago/pagos.jsx";
import FormPago from "./routes/FormPago/formPago.jsx";

import Ganancias from "./routes/ganancia/ganancia.jsx";
import FormGanancia from "./routes/ganancia/formGan.jsx";

import Presupuesto from "./routes/presupuesto/presupuesto.jsx";
import FormPresupuesto from "./routes/presupuesto/formPresupuesto.jsx";
import PresupuestoT from "./routes/presupuestot/presupuestot.jsx";
import FormPresupuestoT from "./routes/presupuestot/formPresupuestot.jsx";

import Factura from "./routes/factura/factura.jsx";
import FormFactura from "./routes/factura/formFactura.jsx";
import Facturat from "./routes/facturat/factura.jsx";
import FormFacturat from "./routes/facturat/formFactura.jsx";
import Compania from "./routes/compania/index";
import FormCompania from "./routes/compania/formCia.jsx";

// import FormNewCia from "./routes/compania/newcia.jsx";

import Test from "./routes/test.jsx";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import Agenda from "./components/calendarComponent.jsx";
import Excel from "./routes/excel/excel.jsx";
import ExcelIO from "./routes/excel/excelTableManager.jsx";
import Porcentaje from "./routes/porcentaje/Porcentaje.jsx";
import FormPorcentaje from "./routes/porcentaje/formPorcentaje.jsx";
import Costo from "./routes/costo/costo.jsx";
import FormCosto from "./routes/costo/formCosto.jsx";
import Compra from "./routes/compra/compra.jsx";
import FormCompra from "./routes/compra/formCompra.jsx";

// Tattoo Compras de productos 
import Compratattoo from "./routes/compratattoo/compratattoo.jsx";
import FormComprat from "./routes/compratattoo/formComprat.jsx";

// Piercing Compras insumos 
import CompraIns from "./routes/comprainsPier/compraIns.jsx";
import FormCompraIns from "./routes/comprainsPier/formCompraIns.jsx";
import ReporteCompra from "./routes/compra/reporteCompras.jsx"
;
// Tattoo Compras Insumos 
import CompraInst from "./routes/comprainsTat/compraInst";
import FormCompraInst from "./routes/comprainsTat/formCompraInst.jsx";
import ReporteCompraInst from "./routes/comprainsTat/reporteComprasInst.jsx";

import Reporte from "./routes/reporte/reporte.jsx";
import Balance from "./routes/reporte/panel.jsx";
import RepCompT from "./routes/reporte/comprast.jsx";
import TablaGasto from "./routes/tablagastos/tablagastos.jsx";
import Gastos from "./routes/gastos/gastos.jsx";
import FormGasto from "./routes/gastos/formGasto.jsx";
import Contratop from "./routes/contrato/contratop.jsx";
import Contratot from "./routes/contrato/contratot.jsx";
import Contratopiercing from "./routes/contrato/piercing.jsx";
import Contratotattoo from "./routes/contrato/tattoo.jsx";
import ContratotattooExt from "./routes/contrato/tattooext.jsx";
import ContratotattooDir from "./routes/contrato/tattooDirecto.jsx";
import Panel from "./routes/panel/suboexcel.jsx";
import Giftcardtat from "./routes/giftcardtat/giftcard.jsx";
import FormGiftcardtat from "./routes/giftcardtat/formGiftcard.jsx";
import Giftcardpier from "./routes/giftcardpier/giftcard.jsx";
import FormGiftcardpier from "./routes/giftcardpier/formGiftcard.jsx";
import Correo from "./routes/emailtemplate/emailtemplate.js"
const router = createBrowserRouter(
   createRoutesFromElements(
      <>
         <Route path="login/" element={<Login />} />
         <Route path="ContratotattooDir/:id?" element={<ContratotattooDir />} />

         <Route
            path="/"
            element={
               <ProtectedRoute>
                  <Root />
               </ProtectedRoute>
            }
            loader={rootLoader}
            action={rootAction}
            errorElement={<ErrorPage />}
         >
            <Route errorElement={<ErrorPage />}>
               <Route index element={<Index />} />
               <Route
                  path="contacts/:contactId"
                  element={<Contact />}
                  loader={contactLoader}
                  action={contactAction}
               />
               <Route
                  path="contacts/:contactId/edit"
                  element={<EditContact />}
                  loader={contactLoader}
                  action={editAction}
               />
               <Route
                  path="contacts/:contactId/destroy"
                  action={destroyAction}
               />
               <Route path="clientes/" element={<Cliente />} />
               <Route path="formCliente/" element={<FormCliente />} />

               <Route path="insumos/" element={<Insumo />} />
               <Route path="formInsumo/" element={<FormInsumo />} />

               <Route path="insumost/" element={<Insumot />} />
               <Route path="formInsumot/" element={<FormInsumot />} />

               <Route path="servicio/" element={<Servicio />} />
               <Route path="formServicio/" element={<FormServicio />} />
               <Route path="formServins/" element={<FormServins />} />

               <Route path="producto/" element={<Producto />} />
               <Route path="formProducto/" element={<FormProducto />} />
               
               <Route path="productotattoo/" element={<Productotattoo />} />
               <Route path="formProductotattoo/" element={<FormProductotattoo />} />   

               <Route path="usuario/" element={<Usuario />} />
               <Route path="FormUsuario/" element={<FormUsuario />} />

               <Route path="factura/" element={<Factura />} />
               <Route path="formFactura/" element={<FormFactura />} />

               <Route path="facturat/" element={<Facturat />} />
               <Route path="formFacturat/" element={<FormFacturat />} />

               <Route path="presupuesto/" element={<Presupuesto />} />
               <Route path="formPresupuesto/" element={<FormPresupuesto />} />

               <Route path="presupuestot/" element={<PresupuestoT />} />
               <Route path="formPresupuestot/" element={<FormPresupuestoT />} />

               <Route path="pagos/" element={<Pagos />} />
               <Route path="formPago/" element={<FormPago />} />

               <Route path="ganancias/" element={<Ganancias />} />
               <Route path="formGanancia/" element={<FormGanancia />} />
               <Route path="test/" element={<Test />} />
               <Route path="compania/" element={<Compania />} />
               <Route path="formCia/" element={<FormCompania />} />
               {/* <Route path="newCia/" element={<FormNewCia />} /> */}

               <Route path="calendario/" element={<Agenda />} />
               <Route path="excel/" element={<Excel />} />
               <Route path="ExcelIO/" element={<ExcelIO />} />
               <Route path="Porcentaje/" element={<Porcentaje />} />
               <Route path="formPorcentaje/" element={<FormPorcentaje />} />
               <Route path="costo/" element={<Costo />} />
               <Route path="formCosto/" element={<FormCosto />} />
               <Route path="Compra/" element={<Compra />} />
               <Route path="formCompra/" element={<FormCompra />} />
               <Route path="formComprat/" element={<FormComprat />} />
               <Route path="compraIns/" element={<CompraIns />} />
               <Route path="formCompraIns/" element={<FormCompraIns />} />
               <Route path="compraInst/" element={<CompraInst />} />
               <Route path="formCompraInst/" element={<FormCompraInst />} />
               <Route path="reporteCompra/" element={<ReporteCompra />} />
               <Route
                  path="reporteCompraInst/"
                  element={<ReporteCompraInst />}
               />
               <Route path="compratattoo" element={<Compratattoo />} />
               <Route path="reporte/" element={<Reporte />} />
               <Route path="balance/" element={<Balance />} />
               <Route path="comprast/" element={<RepCompT />} />
               <Route path="tablagasto/" element={<TablaGasto />} />
               <Route path="gasto/" element={<Gastos />} />
               <Route path="formgasto/" element={<FormGasto />} />
               <Route path="contratop/" element={<Contratop />} />
               <Route path="contratot/" element={<Contratot />} />
               <Route path="Contratopiercing/" element={<Contratopiercing />} />
               <Route path="Contratotattoo/" element={<Contratotattoo />} />
               <Route path="ContratotattooExt/" element={<ContratotattooExt />} />
               <Route path="giftcardtat/" element={<Giftcardtat />} />
               <Route path="formGiftcardtat/" element={<FormGiftcardtat />} /> 
               <Route path="giftcardpier/" element={<Giftcardpier />} />
               <Route path="formGiftcardpier/" element={<FormGiftcardpier />} /> 
               <Route path="Panel/" element={<Panel />} />
               <Route path="Correo/" element={<Correo />} />
            </Route>
         </Route>
      </>
   )
);

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")).render(
   <QueryClientProvider client={queryClient}>
      <AuthProvider>
         {/* <React.StrictMode> */}
         <RouterProvider router={router} />
         <ToastContainer
            position="top-right"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            transition={Zoom}
         />
         {/* </React.StrictMode> */}
      </AuthProvider>
   </QueryClientProvider>
);
